import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "button"];

  connect() {
    console.log("Hello, Stimulus!", this.element);
  }

  toggleForm() {
    this.formTarget.classList.toggle("hidden");
    this.buttonTarget.classList.toggle("opacity-60");
  }
}
